import { getHoffmanEnvironment } from '../../services/windowService';

export enum Environment {
  FAE = 'FAE',
  OAE = 'OAE',
  QSS = 'QSS',
  PROD = 'PROD',
}

export const isTestEnvironment = (): boolean => {
  const { ENVIRONMENT } = getHoffmanEnvironment();
  return !ENVIRONMENT || ENVIRONMENT === Environment.FAE || ENVIRONMENT === Environment.OAE;
};

export const isQssEnvironment = (): boolean => {
  return getHoffmanEnvironment().ENVIRONMENT === Environment.QSS;
};

export const isProdEnvironment = (): boolean => {
  return getHoffmanEnvironment().ENVIRONMENT === Environment.PROD;
};

export const getCurrentEnvironment = (): Environment | undefined =>
  getHoffmanEnvironment().ENVIRONMENT;
